import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-add-product-category',
  templateUrl: './add-product-category.component.html',
  styleUrls: ['./add-product-category.component.css']
})
export class AddProductCategoryComponent implements OnInit {

  cProductList: any= []
  name:any = ""
  description:any = ""
  cid:any;
  done:any = [];
  imageUrl:any = ""
  categoryList:any = [];
  selectedCategoryList:any = [];
  subCategoryList:any = [];
  isHomePage:boolean = false;
  dropdownSettings:IDropdownSettings = {
    singleSelection: false,
    idField: 'productCategoryId',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 2,
    allowSearchFilter: true
  };

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid');
    this.getallproduct()
    this.getAllProductCategory()
  }

  getAllProductCategory(){
    this.generic_service.getAllProductCategory().subscribe(
      (res:any)=> {
        console.log(res)
        this.categoryList = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

  onItemSelect(item: any) {
    console.log(item);
    // let productIndex = 0;
    // for(let i = 0; i < this.relatedProductList.length;i++) {
    //   if(this.relatedProductList[i].productMasterId == item.productMasterId) {
    //     productIndex = i;
    //   }
    // }
    // this.relatedProductList.splice(productIndex,1)
    for(let i = 0; i < this.categoryList.length;i++){
      if(this.categoryList[i].productCategoryId == item.productCategoryId){
        this.subCategoryList.push(
          {
            "categoryId": this.categoryList[i].productCategoryId,
            "categoryName": this.categoryList[i].name,
            "url": this.categoryList[i].imageUrl
          }
        )
      }

    }
  }

  onSelectAll(items: any) {
    console.log(items);

  }

  getallproduct(){
    this.generic_service.getAllProducts().subscribe(
      (response:any)=>{
        console.log(response);
        for(let i=0; i<response.response.length; i++) {
          let defaultUOM:any = ""
          if(response.response[i].supportedUOM != null && response.response[i].supportedUOM != undefined && response.response[i].supportedUOM.length != 0) {
            for(let j=0; j<response.response[i].supportedUOM.length; j++){
              if(response.response[i].supportedUOM[j].isDefault === true) {
                defaultUOM = response.response[i].supportedUOM[j].uomName
              }
            }
          }
          response.response[i].defaultUOM = defaultUOM
        }
        this.cProductList = [];
        for(let i=0; i<response.response.length;i++){
          let body = {
            "productId": response.response[i].productMasterId,
            "name": response.response[i].name,
            "uom": response.response[i].defaultUOM,
            "quantity": 1,
            "price": 0,
            "productUrl": response.response[i].imageUrl,
          }
          this.cProductList.push(body)
        }
        console.log(this.cProductList)
      }
    )
  }


  imageButtonClick(){
    document.getElementById("imageInput")?.click()
  }

  imageRemove(){
    this.imageUrl = ""
  }

  onChange(event: any) {
    this.onUpload(event.target.files[0])
  }

  onUpload(file: any) {
    this.generic_service.uploadImage(file).subscribe(
      (event: any) => {
        this.imageUrl = event.response
      }
    );
  }

  // getAllCProduct(){
  //   this.generic_service.getAllcProductMaster().subscribe(
  //     (response:any)=>{
  //       console.log(response);
  //       this.cProductList = [];
  //       for(let i=0; i<response.response.length;i++){
  //         let body = {
  //           "slNo": 0,
  //           "productId": response.response[i].cproductId,
  //           "code": response.response[i].code,
  //           "name": String(response.response[i].name),
  //           "group": String(response.response[i].group),
  //           "description": String(response.response[i].description),
  //         }
  //         this.cProductList.push(body)
  //       }
  //     }
  //   )
  // }

  add(){
 
    // let subCategoryList: any = []
    // for(let i = 0; i < this.subCategoryList.length;i++){
    //   subCategoryList.push(
    //     {
    //       "categoryId": this.subCategoryList[i].productCategoryId,
    //       "categoryName": this.subCategoryList[i].name,
    //       "url": ""
    //     }
    //   )
    // }

    let body = {
      "version": 0,
      "isActive": true,
      "description": this.description,
      "id": "",
      "slNo": 0,
      "productCategoryId": 0,
      "name": this.name,
      "subCategoryList": this.subCategoryList,
      "productObjList": this.done,
      "cid": Number(this.cid),
      "isHomePage": this.isHomePage,
      "imageUrl": this.imageUrl
    }
    console.log(body)
    this.generic_service.addProductCategory(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllProductCategory()
        this.getallproduct()
        this.name = ""
        this.description = ""
        this.done = [];
        this.subCategoryList = [];
        this.toastr.success(response.message)
      },
      (error:any)=>{
        console.log(error)
      }
    )
  } 

}
